import { Formik } from 'formik';
import T from 'prop-types';
import React from 'react';
import { object, string, boolean } from 'yup';
import Control from '../Control';
import text from '../../../text';
import Checkbox from '../Checkbox';
import Button from '../../button/Button';
var addNoteSchema = object().shape({
    title: string().required(text('required')),
    description: string().required(text('required')),
    sendNotification: boolean()
});
var AddNoteForm = function(props) {
    var projectId = props.projectId, onSubmit = props.onSubmit, onCancel = props.onCancel, addState = props.addState;
    return /*#__PURE__*/ React.createElement("div", {
        className: "AddNoteForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            title: '',
            description: '',
            sendNotification: false
        },
        validationSchema: addNoteSchema
    }, function(param) {
        var handleChange = param.handleChange, handleBlur = param.handleBlur, isValid = param.isValid, values = param.values, errors = param.errors, dirty = param.dirty, touched = param.touched;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Control, {
            required: true,
            label: text('subject'),
            as: "input",
            type: "text",
            name: "title",
            isFailed: touched.title && !!errors.title,
            value: (values === null || values === void 0 ? void 0 : values.title) || '',
            onBlur: handleBlur,
            onChange: handleChange,
            placeholder: text('enterSubject'),
            validationError: errors.title,
            autoComplete: "off"
        }), /*#__PURE__*/ React.createElement(Control, {
            required: true,
            label: text('note'),
            as: "textarea",
            type: "text",
            name: "description",
            isFailed: touched.description && !!errors.description,
            value: (values === null || values === void 0 ? void 0 : values.description) || '',
            onBlur: handleBlur,
            onChange: handleChange,
            placeholder: text('enterNote'),
            validationError: touched.description && errors.description,
            autoComplete: "off"
        }), /*#__PURE__*/ React.createElement(Checkbox, {
            onChange: handleChange,
            name: "sendNotification",
            value: values === null || values === void 0 ? void 0 : values.sendNotification,
            label: text('sendNotificationToCustomer')
        }), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer"
        }, /*#__PURE__*/ React.createElement(Button, {
            loading: addState.loading,
            onClick: function() {
                return onSubmit(projectId, values);
            },
            disabled: !isValid || !dirty
        }, text('add')), /*#__PURE__*/ React.createElement("a", {
            name: "cancel",
            href: "#",
            onClick: onCancel
        }, text('cancel'))));
    }));
};
AddNoteForm.propTypes = {
    onSubmit: T.func.isRequired,
    onCancel: T.func.isRequired,
    addState: T.shape(),
    projectId: T.number
};
export default AddNoteForm;
